import CancelInf from "./inf";

type IProps = {
  cnlResvInf: any;
  handleResvCancel(): void;
};

export default function CancelBookView({
  cnlResvInf,
  handleResvCancel,
}: IProps) {
  return (
    <>
      <CancelInf cnlResvInf={cnlResvInf} handleResvCancel={handleResvCancel} />
    </>
  );
}
